import { createContext, useState, useEffect } from 'react'
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { doc, getDoc, setDoc } from 'firebase/firestore'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { auth, db } from '../services/firebaseConnection'

export const AuthContext = createContext({})

export function ProviderContext({ children }) {
  const [user, setUser] = useState(null)
  const [loadingAuth, setLoadingAuth] = useState(false)
  const [loading, setLoading] = useState(true)

  const [questions, setQuestions] = useState([])
  // const [userP, setUserP] = useState({
  //   id: "231jindf",
  //   email: "teste@email.com",
  //   nome: "Testador"
  // })

  const navigate = useNavigate()

  // Verifica usuário logado Pantheon
  // useEffect(() => {
  //   const fetchUser = async () => {
  //     try {
  //       const response = await fetch('https://pantheonconcursos.com.br/wp-json/custom/v1/usuario-logado', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         credentials: 'include' // Inclui cookies na solicitação
  //       });

  //       console.log("response: ", response)

  //       if (!response.ok) {
  //         throw new Error('Erro ao buscar dados do usuário logado');
  //       }

  //       const data = await response.json();
  //       setUserP(data);
  //     } catch (error) {
  //       console.error("error: ", error);
  //     }
  //   };

  //   fetchUser();
  // }, []);

  useEffect(() => {
    async function loadUser() {
      const storageUser = localStorage.getItem("@dataUser")

      if (storageUser) {
        setUser(JSON.parse(storageUser))
        setLoading(false)
      }

      setLoading(false)
    }

    loadUser()
  }, [])

  // Usado para cadastrar quando estudante não tiver cadastrodo
  async function signUpStudent(userP) {
    console.log("userP-Auth: ", userP)
    setLoadingAuth(true)

    await createUserWithEmailAndPassword(auth, userP.email, userP.password)
      .then(async (value) => {
        let uid = value.user.uid

        await setDoc(doc(db, "users", uid), {
          name: userP.nome,
          idP: userP.id,
          avatarUrl: null,
          uid: uid,
          email: userP.email,
          password: userP.password,
          status: {
            adm: false,
            collaborator: false,
            student: true
          }
        })
          .then(() => {
            setLoadingAuth(false)
            toast.success("Cadastrado com sucesso")
            navigate("/questoes-publicas")
          })
      })
      .catch((err) => {
        console.log(err)
        setLoadingAuth(false)
        toast.error("Ops... erro ao se cadastrar")
      })
  }

  // Usado para fazer login quando o usuario ja estiver cadastrado na base de dados
  async function signInUser(email, password) {
    console.log("email: ", email)
    console.log("password: ", password)

    setLoadingAuth(true)

    await signInWithEmailAndPassword(auth, email, password)
      .then(async (value) => {
        //console.log("value: ", value)
        const uid = value.user.uid

        const docRef = doc(db, "users", uid)
        //console.log("docRef: ", docRef)
        const docSnap = await getDoc(docRef)
        console.log("DATA: ", docSnap.data())

        let data = {
          uid: uid,
          name: docSnap.data().name,
          email: value.user.email,
          avatarUrl: docSnap.data().avatarUrl,
          status: docSnap.data().status,
          adm: docSnap.data().adm
        }

        setUser(data)
        storageUser(data)
        setLoadingAuth(false)
        toast.success("Usuario logado com sucesso")
        navigate("/questoes")
      })
      .catch((err) => {
        console.log(err)
        setLoadingAuth(false)
        toast.error("Ops... erro ao tentar acessar")
      })
  }

  // Usado para cadastrar novo colaborador
  async function signUpCollaboratorUser(name, email, password) {
    //console.log(email)
    setLoadingAuth(true)

    await createUserWithEmailAndPassword(auth, email, password)
      .then(async (value) => {
        //console.log(value)
        let uid = value.user.uid

        await setDoc(doc(db, "users", uid), {
          name: name,
          avatarUrl: null,
          uid: uid,
          email: email,
          password: password,
          status: {
            adm: false,
            collaborator: true,
            student: false
          }
        })
          .then(() => {
            // let data = {
            //   uid: uid,
            //   name: name,
            //   email: value.user.email,
            //   avatarUrl: null,
            //   status: value.user.status
            // }

            //setUser(data)
            //storageUser(data)
            setLoadingAuth(false)
            toast.success("Cadastrado com sucesso")
          })
      })
      .catch((err) => {
        console.log(err)
        setLoadingAuth(false)
        toast.error("Ops... erro ao se cadastrar")
      })
  }

  async function logOut() {
    await signOut(auth)
    localStorage.removeItem("@dataUser")
    setUser(null)
  }

  function storageUser(data) {
    localStorage.setItem("@dataUser", JSON.stringify(data))
  }


  return (
    <AuthContext.Provider
      value={{
        signed: !!user,
        user,
        setUser,
        signInUser,
        signUpStudent,
        signUpCollaboratorUser,
        logOut,
        loadingAuth,
        loading,
        questions,
        setQuestions,
        storageUser
      }} >
      {children}
    </AuthContext.Provider>
  )
}